import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import VideoClip from "../../../../models/media/VideoClip";
import * as AnalyticsStore from "../../../../store/analytics/Analytics";
import { useLazyGetStoredFileForMediaQuery } from "../../../../store/api/kinesense";
import { Notifications } from "../../../../utilities/Notifications/Notifications";
import { DateFormats } from "../../../../utilities/dates";
import { tryExtractErrorMessage } from "../../../../utilities/helpers";
import { ReviewVideoListItemTrayContentProps } from "./ReviewVideoListItemFooter";

export type ReviewVideoListItemClipProps = ReviewVideoListItemTrayContentProps & {
    clip: VideoClip;
};

export default function ReviewVideoListItemClip(props: ReviewVideoListItemClipProps) {
    const dispatch = useDispatch();

    const [requestStoredFile] = useLazyGetStoredFileForMediaQuery();
    const [isDownloadingFile, setIsDownloadingFile] = useState(false);

    async function downloadClip(fileId: string) {
        setIsDownloadingFile(true);

        try {
            const storedFile = await requestStoredFile({
                projectId: props.data.projectId,
                mediaId: props.data.mediaId,
                fileId: props.clip.fileId,
            }).unwrap();
            const resp = await fetch(storedFile.accessUrl.url);
            const url = URL.createObjectURL(await resp.blob());
            const a = document.createElement("a");
            a.href = url;
            a.download = `${props.data.name}_clip_${fileId}`;
            a.click();

            URL.revokeObjectURL(url);
        } catch (e) {
            Notifications.notify(
                "Failed to download clip",
                `The following error was encountered while attempting to download a clip: ${tryExtractErrorMessage(e)}`,
            );
        }

        setIsDownloadingFile(false);
    }

    function jumpToTime(startOffset: number) {
        dispatch(
            AnalyticsStore.actionCreators.setPrimaryCursorPosition(
                props.viewId,
                props.data.startsAt + startOffset,
                "other",
                "reviewVideoListClips",
            ),
        );
        dispatch(
            AnalyticsStore.actionCreators.setSecondaryCursorPosition(props.viewId, undefined, "reviewVideoListClips"),
        );
    }

    return (
        <>
            <tr>
                <td colSpan={3} style={{ paddingTop: "0rem", fontVariant: "small-caps" }}>
                    {props.clip.name}
                </td>
            </tr>
            <tr style={{ fontSize: "smaller" }}>
                <td>
                    <a
                        title="Start Time - Click to jump to clip start time"
                        style={{ cursor: "pointer", textDecoration: "underline", textDecorationStyle: "dotted" }}
                        onClick={(e) => {
                            e.preventDefault();
                            jumpToTime(props.clip.startAt);
                        }}
                    >
                        {dayjs(props.data.startsAt + props.clip.startAt).format(
                            DateFormats.dayMonthYearWithTimeSeconds,
                        )}
                    </a>
                </td>
                <td title="Duration">{dayjs.duration(props.clip.endAt - props.clip.startAt).humanize()}</td>
                <td style={{ textAlign: "right" }}>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            downloadClip(props.clip.fileId);
                        }}
                        style={{ display: "inline" }}
                        title="Download Clip"
                        className="button-with-icon"
                        disabled={isDownloadingFile}
                    >
                        {isDownloadingFile ? <Spinner size="sm" /> : <FontAwesomeIcon icon={faDownload} />}
                    </button>
                </td>
            </tr>
            <tr>
                <td colSpan={3}></td>
            </tr>
        </>
    );
}
